import React from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";

export default function IncomeCard({ incomeStatement, activeTabIndex = 1 }) {
  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    <div>
      <div className="bg-white rounded-lg border border-gray-300 w-full my-5">
        <div className="text-black rounded-t-lg bg-[#d1d5db]">
          <h2 className="text-lg font-semibold p-2">{t("IncomeStatement")}</h2>
        </div>
        <div className="space-y-3 p-2">
          <div
            className="flex justify-between cursor-pointer hover:bg-gray-100 p-1 hover:rounded-md"
            onClick={() => {
              navigate("/manager/report/income-details", {
                state: {
                  accountsData: incomeStatement?.data?.expenses?.accounts || [],
                  title: t("Expenses"),
                  activeTabIndex,
                },
              });
            }}
          >
            <span className="font-medium">{t("Expenses")}:</span>
            <span>
              {incomeStatement?.data?.expenses?.total} {t("SAR")}
            </span>
          </div>
          <div
            className="flex justify-between cursor-pointer hover:bg-gray-100 p-1 hover:rounded-md"
            onClick={() => {
              navigate("/manager/report/income-details", {
                state: {
                  accountsData: incomeStatement?.data?.revenues?.accounts || [],
                  title: t("Revenue"),
                  activeTabIndex,
                },
              });
            }}
          >
            <span className="font-medium">{t("Revenue")}:</span>
            <span>
              {incomeStatement?.data?.revenues?.total} {t("SAR")}
            </span>
          </div>
          <div className="flex justify-between p-1 cursor-default hover:bg-gray-100 p-1 hover:rounded-md">
            <span className="font-medium">{t("Income")}:</span>
            <span>
              {incomeStatement?.data?.net_income} {t("SAR")}
            </span>
          </div>
        </div>
      </div>
    </div>
  );
}
